export const showHeapsGoBranding =
  process.env.GATSBY_HIDE_HEAPSGO_BRANDING === "true" ? false : true
